// Gestion du consentement cookies (CNIL) : aucun traceur n'est chargé tant que
// l'utilisateur n'a pas accepté explicitement.

const STORAGE_KEY = "tef_consentement_cookies";
const DUREE_VALIDITE_MOIS = 6; // recommandation CNIL : consentement redemandé au bout de 6 mois

const GA_ID = "G-F4FZJJRNDP";
const POSTHOG_KEY = "phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE";
const POSTHOG_HOST = "https://us.i.posthog.com";

export const EVENEMENT_OUVERTURE = "tef-ouvrir-preferences-cookies";

// Retourne { statut: "accepte" | "refuse", date } ou null si aucun choix valide
export const lireConsentement = () => {
  try {
    const brut = window.localStorage.getItem(STORAGE_KEY);
    if (!brut) return null;

    const choix = JSON.parse(brut);
    if (!choix || !choix.statut || !choix.date) return null;

    const limite = new Date(choix.date);
    limite.setMonth(limite.getMonth() + DUREE_VALIDITE_MOIS);
    if (new Date() > limite) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return choix;
  } catch (e) {
    return null;
  }
};

export const enregistrerConsentement = (statut) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ statut, date: new Date().toISOString() })
    );
  } catch (e) {
    // navigation privée ou stockage indisponible : on ne bloque pas l'utilisateur
  }
};

let mesureChargee = false;

// Charge Google Analytics et PostHog. Idempotent.
export const chargerMesureAudience = () => {
  if (mesureChargee || typeof window === "undefined") return;
  mesureChargee = true;

  // Google Analytics
  const scriptGa = document.createElement("script");
  scriptGa.async = true;
  scriptGa.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(scriptGa);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  // PostHog
  const scriptPosthog = document.createElement("script");
  scriptPosthog.async = true;
  scriptPosthog.crossOrigin = "anonymous";
  scriptPosthog.src = `${POSTHOG_HOST.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
  scriptPosthog.onload = () => {
    if (window.posthog && typeof window.posthog.init === "function") {
      window.posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "identified_only",
      });
    }
  };
  document.head.appendChild(scriptPosthog);
};

// Supprime les cookies déposés par GA et PostHog lors d'une visite précédente
export const supprimerCookiesMesure = () => {
  try {
    const domaine = window.location.hostname.replace(/^www\./, "");
    document.cookie.split(";").forEach((cookie) => {
      const nom = cookie.split("=")[0].trim();
      if (/^(_ga|_gid|_gat|ph_)/.test(nom)) {
        document.cookie = `${nom}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        document.cookie = `${nom}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domaine}`;
      }
    });
  } catch (e) {
    // rien à faire : la suppression est un effort au mieux
  }
};

// Applique le choix déjà stocké au chargement de l'application
export const appliquerConsentementExistant = () => {
  const choix = lireConsentement();
  if (choix && choix.statut === "accepte") chargerMesureAudience();
  return choix;
};

export const ouvrirPreferences = () => {
  window.dispatchEvent(new CustomEvent(EVENEMENT_OUVERTURE));
};
